import {IBaseLookup} from "./Ibase.lookup";

export namespace ResourceRole {

    export const lookupName: string = "ResourceRole";

    export interface ResourceRole {
        resourceRoleKey: number;
        code: string;
        description: string;
        active: string;
        lastUpdated: Date;
    }

    export interface ResourceRoleDS extends IBaseLookup {
        resourceRole: ResourceRole[];
    }
}
